module.exports = __webpack_public_path__ + "static/img/yixi_logo_square.ec391afd.png";